/**
 * Проверяет, было ли уведомление показано в течение определенного периода времени
 * @param {string} key - Ключ в localStorage для проверки
 * @param {number} period - Период времени в миллисекундах (например, 24 * 60 * 60 * 1000 для 1 дня)
 * @returns {boolean} - true, если уведомление было показано в течение периода, false в противном случае
 */
export function wasNotificationShown(key, period = 24 * 60 * 60 * 1000) {
  // По умолчанию 24 часа
  const lastShown = localStorage.getItem(key)
  if (!lastShown) return false

  const lastShownTime = parseInt(lastShown)
  const currentTime = new Date().getTime()

  // Проверяем, находится ли разница во времени в пределах указанного периода
  return currentTime - lastShownTime < period
}

/**
 * Отмечает уведомление как показанное с текущим временем
 * @param {string} key - Ключ в localStorage для установки
 */
export function markNotificationAsShown(key) {
  const now = new Date().getTime()
  localStorage.setItem(key, now.toString())
}
